'use client';

import { useState } from 'react';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import MarketStatus from './components/MarketStatus';
import MarketTabs from './components/MarketTabs';
import CityGoldRates from './components/CityGoldRates';
import AdSense from '@/components/adsense/AdSense';

export default function Markets() {
  const [activeTab, setActiveTab] = useState('tab_stocks');

  return (
    <>
      <Header />
      <main className="min-h-screen pt-32 pb-16">
        <div className="container mx-auto px-4 max-w-7xl">
          {/* Page Header */}
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4 font-display">
              Live Market Data
            </h1>
            <p className="text-xl text-muted-foreground mb-6">
              Real-time prices from NSE, BSE, MCX, and global exchanges
            </p>
            <MarketStatus />
          </div>

          {/* AdSense Ad */}
          <div className="mb-8">
            <AdSense
              adClient={process.env.NEXT_PUBLIC_ADSENSE_ID || ''}
              adSlot="1122334455"
              adFormat="auto"
              adStyle={{ display: 'block', minHeight: '250px' }}
            />
          </div>

          {/* Market Tabs */}
          <MarketTabs activeTab={activeTab} onTabChange={setActiveTab} />

          {/* City Gold Rates */}
          {activeTab === 'tab_commodities' && (
            <div className="mt-12">
              <CityGoldRates />
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}